import {cn} from '@bem-react/classname';

export const cnPromoPage = cn('PromoPage');
